export const Action = {
    GET_DOMAINS: "GET_DOMAINS",
    ADD_DOMAIN: "ADD_DOMAIN",
    GET_DOMAINS_VERIFY: "GET_DOMAINS_VERIFY",
    CHANGE_DOMAIN: "CHANGE_DOMAIN",
    DELETE_DOMAIN: "DELETE_DOMAIN"
};
export const Mutation = {
    SAVE_DOMAINS: "SAVE_DOMAINS"
};